module.exports = __webpack_public_path__ + "img/258-17988c.png";